export function getFocusableNodes(element) {
    return Array.from(element.querySelectorAll('a:not([disabled]), button:not([disabled]), ' +
        'input[type=text]:not([disabled]), ' +
        '[tabindex]:not([disabled]):not([tabindex="-1"])'));
}
//# sourceMappingURL=focus.js.map